<template>
  <div>
    <p
      :for="name"
      class="text-sm text-gray-600 truncate mb-2"
    >
      {{ libelle }}
    </p>
    <div class="flex flex-col items-center">
      <input
        :name="name"
        :min="0"
        :max="rangeValues.length-1"
        type="range"
        v-model="mutableValue"
        :class="'slider appearance-none focus:outline-none focus:outline-indigo h-0 rounded border border-pink-600 w-full'"
        :necessary="progressCount"
        :disabled="disabled || disabled_pass"
      >
      <p 
        :class="sizeLibelle+' '+colorLibelle+' '+weightLibelle+' mt-1.5 cursor-default'"
      >
        {{ rangeValues[mutableValue] }}
      </p>
    </div>
  </div>
</template>

<script>
import Icon from '../../components/Icon';

export default {
  components: {
    Icon
  },

  props:{
    name: String,
    libelle: String,
    value: Number,
    necessary: Boolean,
    colorLibelle:{
      type: String,
      required: false,
      default: 'text-gray-900'
    },
    sizeLibelle:{
      type: String,
      required: false,
      default: 'text-base'
    },
    weightLibelle:{
      type: String,
      required: false,
      default: 'font-normal'
    },
    disabled:{
      type: Boolean,
      required: false,
      default: false
    },
    colorBorder:{
      type:String,
      required:false,
      default:'border-indigo-600'
    },
    rangeValues: Array,
  },
  data: function () {
    return {
      mutableValue: this.value != undefined ? this.value : 0,
      progressCount:true,
      disabled_pass: false,
    };
  },
  mounted(){
    // Manage edit permission for neopass pages
    if(this.$route.path.includes('form/neopass') && !this.forceActiveInNeopassForm){
      let idpass = this.$route.path.split('/form/neopass/')[1].split('/')[0];
      let page = this.$route.path.split('/form/neopass/')[1].split('/')[2];
      if(this.$can(page+'_edit', idpass)){
        this.disabled_pass = false;
      }
      else{
        this.disabled_pass =  true;
      }
    }else{
      this.disabled_pass = false;
    }

    //assign "necessary" prop value to "progressCount" data if this prop is filled
    if(this.necessary != undefined && !this.necessary){
      this.progressCount = false;
    }
  },
  methods:{
    //
  },
  watch: {
    mutableValue(){
      this.$emit('input', this.mutableValue);
    }
  }
};
</script>

<style scoped>
    .slider::-webkit-slider-runnable-track{
        -webkit-appearance: none;
        height: 20px;
    }

    /* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
    .slider::-webkit-slider-thumb {
        -webkit-appearance: none; /* Override default look */
        appearance: none;
        width: 10px; /* Set a specific slider handle width */
        height: 10px; /* Slider handle height */
        background: #FF1C80; /* Green background */
        border-color: #FF1C80;
        cursor: pointer; /* Cursor on hover */
        border: 0;
        border-radius: 9999px;
        margin-top:5px;
    }

    .slider::-moz-range-thumb {
        width: 10px; /* Set a specific slider handle width */
        height: 10px; /* Slider handle height */
        background: #FF1C80; /* Green background */
        border-color: #FF1C80;
        cursor: pointer; /* Cursor on hover */
    }

    .slider::-moz-range-track {
        background-color: #FBE6F0;
    }
    .slider::-moz-range-progress {
        background-color: #FF1C80;
    }
    .slider::-ms-fill-upper {
        background-color: #FBE6F0;
    }
    .slider::-ms-fill-lower {
        background-color: #FF1C80;
    }
</style>
